import { render, staticRenderFns } from "./Gcoin.vue?vue&type=template&id=572b58b5&scoped=true&"
import script from "./Gcoin.vue?vue&type=script&lang=js&"
export * from "./Gcoin.vue?vue&type=script&lang=js&"
import style0 from "./Gcoin.vue?vue&type=style&index=0&id=572b58b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b58b5",
  null
  
)

export default component.exports